import {Component, Vue} from 'vue-property-decorator';
import currencyList, {currency, currencyOrderSizeEnum, orderIndex} from './currency-list';

@Component
export default class CurrencyMixin extends Vue {
  get currencies(): {[type: string]: string} {
    return currencyList;
  }

  get currencyOrderSizeEnum() {
    return currencyOrderSizeEnum;
  }

  fillCurrencies(item) {
    return {
      ...item,
      name: this.t(item.name),
      sign: this.currencies[item.code],
      index: orderIndex[item.code].index,
      size: orderIndex[item.code].size
    }
  }

  sortCurrencies(items) {
    return items.sort((a, b) => {
      const aVal = a.index;
      const bVal = b.index;

      return aVal > bVal
        ? 1
        : aVal < bVal
          ? -1
          : 0;
    })
  }

  get currencyList() {
    return this.$store.state.currencyList || []
  }

  get currencyListOrderedPreferred() {
      const preferredCurrency = this.$store.state.user.preferredCurrency;

      const result: any[] = this.currencyList
        .filter((item: currency) => preferredCurrency.includes(item.code) && !!this.currencies[item.code])
        .map(this.fillCurrencies);

      return this.sortCurrencies(result);
    }

  get currencyListOrdered() {
    const result: any[] = this.currencyList
      .filter((item: currency) => !!this.currencies[item.code])
      .map(this.fillCurrencies);

    return this.sortCurrencies(result);
  }

  get currenciesLowerCase(): {[type: string]: string} {
    const result: {[type: string]: string} = {};

    const keys = Object.keys(this.currencies);

    keys.forEach((key) => {
      result[key.toLowerCase()] = this.currencies[key];
    });

    return result;
  }
}
